<template>
	<div id="app">
		<router-view></router-view>
	</div>

</template>

<script>
	export default {
		name: 'App',
		components: {

		}
	}
</script>

<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;

	}

	body,
	ul,
	li,
	dl,
	dt,
	dd,
	p,
	ol,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	form,
	img,
	table,
	fieldset,
	legend {
		margin: 0;
		padding: 0;
	}

	ul,
	li,
	ol {
		list-style: none;
	}

	img,
	fieldset {
		border: 0;
	}

	img {
		display: block;
	}

	a {
		text-decoration: none;
		color: #333;
	}

	i,
	em {
		font-style: normal;
	}

	b {
		font-style: normal;
		font-weight: normal;
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		font-weight: 100;
	}

	input::-webkit-input-placeholder {
		color: #c9c9c9;
	}

	body {
		font-size: 14px;
		color: #333;
		font-family: PingFangSC-Regular, sans-serif;
		-webkit-overflow-scrolling: touch;
		overflow-scrolling: touch;
		touch-action: none;
		
	}
</style>
